export const BASE_URL = process.env.REACT_APP_API_URL;
export const LIVE_WEBSITE_URL = process.env.REACT_APP_LIVE_WEBSITE_URL;
let ApiConfig = {
  BASE_URL,
  LIVE_WEBSITE_URL,

  // Auth Apis
  authRegister: `${BASE_URL}api/auth/register`,
  authLogin: `${BASE_URL}api/auth/login`,
  authForgotPwd: `${BASE_URL}api/auth/forgot-password-email`,
  authUpdatePwd: `${BASE_URL}api/auth/forgot-password`,
  authSignup: `${BASE_URL}api/auth/register`,
  authGetUser: `${BASE_URL}api/auth/user`,
  authLookingFor: `${BASE_URL}api/property-type`,
  contactUs: `${BASE_URL}api/contact-us`,
  authPropertySubCat: `${BASE_URL}api/property-subcategory`,
  authLogout: `${BASE_URL}api/auth/logout`,
  verifyEmailOtp: `${BASE_URL}api/auth/verify-email-otp`,
  verifyEmailOtpLogin: `${BASE_URL}api/auth/verify-email-otp-login`,
  resendEmailOtp: `${BASE_URL}api/auth/otp-resend-email`,
  //Agent dashboard Flow APIs
  agentNewRegister: `${BASE_URL}api/auth/new-agent-register`,
  agentRegister: `${BASE_URL}api/auth/agent-register`,
  agentLogin: `${BASE_URL}api/auth/agent-login`,
  resetAgentPassword: `${BASE_URL}api/reset-password`,
  updateAgentProfile: `${BASE_URL}api/update-profile`,
  myParentsAgentsList: `${BASE_URL}api/referral-agent-list`,
  childAgentsList: `${BASE_URL}api/child-agent-list`,
  myCommissionSale: `${BASE_URL}api/agent-commission-sale`,
  myCommissionAudit: `${BASE_URL}api/agent-commission-rent`,
  getAgentCodeSearch: `${BASE_URL}api/auth/agent-code-search`,

  // View property api
  propertyList: `${BASE_URL}api/property-list`,

  // add and remove property to wishlist API
  addToWishlist: `${BASE_URL}api/property-add-wishlist`,
  removeFromWishlist: `${BASE_URL}api/property-remove-wishlist`,
  userWishlists: `${BASE_URL}api/my-wishlisted-property`,
  userMyScheduleVisits: `${BASE_URL}api/my-schedule-visit-list`,

  //Social Login
  socialLogin: `${BASE_URL}api/login/`,
  userDetails: `${BASE_URL}api/user`,

  agentPopertyToBeAudited: `${BASE_URL}api/property-to-be-audited-list`,
  agentPopertyScheduledForAudited: `${BASE_URL}api/property-scheduled-for-audited-list`,
  agentPropertyBookedForVisit: `${BASE_URL}api/property-booked-visit-agent`,
  agentPropertyScheduledForVisit: `${BASE_URL}api/property-scheduled-for-visit-agent`,

  // Post Property APIs

  allPropertyTypes: `${BASE_URL}api/property-type`,
  allPropertyCategory: `${BASE_URL}api/property-category`,
  propertySubCategory: `${BASE_URL}api/property-subcategory`,
  postNewProperty: `${BASE_URL}api/create-property`,
  allMyPostedProperty: `${BASE_URL}api/user-property-list`,
  singlePropertyDetail: `${BASE_URL}api/property-single`,
  deleteSingleMyProperty: `${BASE_URL}api/property-delete`,

  // Visit Property Api
  getTimeSlots: `${BASE_URL}api/timeslot-list`,

  // Admin APIS
  propertyVisitRequestAccept: `${BASE_URL}api/property-visit-request-accept`,

  //Buy property
  schedulePropertyAudit: `${BASE_URL}api/property-schedule-audit`,
  scheduleAuditList: `${BASE_URL}api/my-schedule-audit-list`,
  cancelAuditAppointment: `${BASE_URL}api/property-audit-cancelled`,
  markAuditComplete: `${BASE_URL}api/property-audit-complete`,
  // Visit Property Api
  getTimeSlots: `${BASE_URL}api/timeslot-list`,

  //Property Visit
  schedulePropertyVisit: `${BASE_URL}api/property-schedule-visit`,
  scheduleVisitList: `${BASE_URL}api/my-schedule-visit-list`,
  cancelVisitAppointment: `${BASE_URL}api/property-visit-cancel`,
  markVisitComplete: `${BASE_URL}api/property-visit-complete`,

  //Homepage
  homepagePropertyList: `${BASE_URL}api/property-homepage-type-list`,
  agentList: `${BASE_URL}api/agent-homepage-list`,
  testimonialList: `${BASE_URL}api/testimonial`,
  propertyLatestDeal: `${BASE_URL}api/property-latest-deal`,

  /////History && Notifications
  historyListData: `${BASE_URL}api/history`,
  notificationsListData: `${BASE_URL}api/notification`,
  clearHistory: `${BASE_URL}api/clear-history`,
  clearNotifications: `${BASE_URL}api/clear-notification`,

  //Home Property Category (Open API)
  homePropertyCategory: `${BASE_URL}api/property-filter-list`,

  //Province-City-District
  provinceDistrictList: `${BASE_URL}api/province`,

  //Similar Property API
  similarproperty: `${BASE_URL}api/property-similar-list`,

  //Property Rating API
  propertyRating: `${BASE_URL}api/property-rating`,
  updatePropertyRating: `${BASE_URL}api/property-rating-update`,
  deletePropertyRating: `${BASE_URL}api/property-rating-delete`,

  // FAQ Pages
  faqs: `${BASE_URL}api/faqs`,
  faqCategories: `${BASE_URL}api/faq-categories`,

  // Legal pages
  termsConditions: `${BASE_URL}api/terms-conditions`,
  privacyPolicy: `${BASE_URL}api/privacy-policy`,
};

export default ApiConfig;
